(function (api) {

	api.KRadnikById = KRadnikById;
	api.GetBrojMjeseci = GetBrojMjeseci;
	api.PodaciORadnikuNaslijedi = PodaciORadnikuNaslijedi;
	api.PonistiKOcjene = PonistiKOcjene;
	api.PonistiCOcjene = PonistiCOcjene;
	api.GetNRMjestoKOcjene = GetNRMjestoKOcjene;
	api.ObrisiKPonasanja = ObrisiKPonasanja;
	
	api.GetKalendarKRadnik = GetKalendarKRadnik;
	api.GetKalendarOdjel = GetKalendarOdjel;
	api.GetKalendarOVrsta = GetKalendarOVrsta;
	api.GetRjesenjaPodredEvents = GetRjesenjaPodredEvents;
	
	api.GetKalendarRadnik = GetKalendarRadnik;
	api.GetKalendarRMjesto = GetKalendarRMjesto;
	api.GetKalendarVRada = GetKalendarVRada;
	api.GetERVEvents = GetERVEvents;
	api.Odobravanje = Odobravanje;
	api.StornirajZahtjevBezStatusa = StornirajZahtjevBezStatusa;
	api.DZahtjevMozeStorno = DZahtjevMozeStorno;
	api.GetRUsavrRadnikaFields = GetRUsavrRadnikaFields;
	api.GetKROstaloRadnikaFields = GetKROstaloRadnikaFields;
	api.GetObiteljRadnikaFields = GetObiteljRadnikaFields;
	api.GetORMjestoRadnikaFields = GetORMjestoRadnikaFields;
	api.GetStaroPRadnikaFields = GetStaroPRadnikaFields;
	api.EduPlanGeneriraj = EduPlanGeneriraj;	
	
	//plan edukacija
	api.GetEduPlanSFields = GetEduPlanSFields;
	api.GetEduPlanSTrFields = GetEduPlanSTrFields;
	api.GetEduKatalogTrFields = GetEduKatalogTrFields;
	api.GetEduPlanSTFields = GetEduPlanSTFields;
	api.EduPlanSObrisi = EduPlanSObrisi;	
	api.EduPlanSTrObrisi = EduPlanSTrObrisi;	
	
	api.GetSlikaRadnika = GetSlikaRadnika;
	api.SpremiIRekapRadnikPredlozak = SpremiIRekapRadnikPredlozak;
	api.ObrisiIRekapRadnikPredlozak = ObrisiIRekapRadnikPredlozak;
	
	api.KRadnikGetPromjenePodataka = KRadnikGetPromjenePodataka;
	api.DajPopisPromjenaPKRadnik = DajPopisPromjenaPKRadnik;
	api.DajPopisPromjenaPrikazKRadnik = DajPopisPromjenaPrikazKRadnik;
	
	//dodatni sifarnici na pregledu kradnika
	api.GetObiteljFields = GetObiteljFields;
	api.GetRUSavrFields = GetRUSavrFields;
	api.GetSJezikFields = GetSJezikFields;
	api.GetKROstaloFields = GetKROstaloFields;
	api.GetStaroPFields = GetStaroPFields;
	api.GetPodsjetiFields = GetPodsjetiFields;
	api.GetKorisnik2RadnikaFields = GetKorisnik2RadnikaFields;
	api.GetKRUgovorFields  = GetKRUgovorFields ;
	api.GetOcListKRFields  = GetOcListKRFields ;
	
	api.ObiteljObrisi = ObiteljObrisi;
	api.RUSavrObrisi = RUSavrObrisi;
	api.SJezikObrisi = SJezikObrisi;
	api.KROstaloObrisi = KROstaloObrisi;
	api.StaroPObrisi = StaroPObrisi;
	api.PodsjetiObrisi = PodsjetiObrisi;
	api.AzurirajOdb = AzurirajOdb;
	api.SpremiKRadnikInitDefaults = SpremiKRadnikInitDefaults;
	api.GenerirajERVZaKRadnik = GenerirajERVZaKRadnik;
	api.RjesenjeObrisi = RjesenjeObrisi;
	
	api.IzracunajStazIzmedju = IzracunajStazIzmedju;
	api.GetNoviRedniZaKRadnik = GetNoviRedniZaKRadnik;
	api.UskladiStazRadnika = UskladiStazRadnika;
	
	//dodatni sifarnici na pregledu dopusta
	api.GetDOsnovaFields = GetDOsnovaFields;
	api.GetDRazdobFields = GetDRazdobFields;
	api.DRazdobObrisi = DRazdobObrisi;
	api.DOsnovaObrisi = DOsnovaObrisi;
	api.DopustObrisi = DopustObrisi;
	api.PostojeZahtjeviZaDopust = PostojeZahtjeviZaDopust;
	api.NapuniDaneZaOsnovu = NapuniDaneZaOsnovu;
	api.DajBrZahtjevaZaImportGen = DajBrZahtjevaZaImportGen;
	api.DRazdobObrisiZaImportGen = DRazdobObrisiZaImportGen;
	api.NapuniRjZaObrisiNadatum = NapuniRjZaObrisiNadatum;
	api.ObrisiRjesenjaNadatum = ObrisiRjesenjaNadatum;
	api.GetORMjestoFields = GetORMjestoFields;
	api.DajVrstaOcZaKRadnik = DajVrstaOcZaKRadnik;
	
	api.GenDopustPregled = GenDopustPregled;
	api.ArhiviranjeRjesenja = ArhiviranjeRjesenja;
	api.VanjskiObrisi = VanjskiObrisi;
	api.ImportIzSc = ImportIzSc;
	
	api.OcRazgovorObrisi = OcRazgovorObrisi;
	
	api.GetKrZnZvanjeFields = GetKrZnZvanjeFields;
	
	function GetKrZnZvanjeFields(kradnik){
			return $.dsDirectCall({
				method: "GetKrZnZvanjeFields",
				params: [ kradnik ]
			});
		}
	 
	function OcRazgovorObrisi(ocrazgovor){
			return $.dsDirectCall({
				method: "OcRazgovorObrisi",
				params: [ ocrazgovor ]
			});
		}
	
	function ArhiviranjeRjesenja(forma, errorOverride){
		return $.dsDirectCallPost({
			method: "ArhiviranjeRjesenja",
			controller: "dopust",	
			data: [ forma ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
				KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}
		});
	}
	
	function GenDopustPregled(forma, errorOverride){
			return $.dsDirectCallPost({
				method: "GenDopustPregled",
				controller: "dopust",	
				data: [ forma ],
				fail: function (error, textStatus, jqXHR, logicalError){ 
					KUtils.busy(false);
					if (errorOverride){
						jqXHR.statusText = "errorOverride"; 
					}
				}
			});
		}
	
	function DajVrstaOcZaKRadnik(kradnik){
		return $.dsDirectCall({
			method: "DajVrstaOcZaKRadnik",
			params: [ kradnik ]
		});
	}
	
	function GetORMjestoFields(){
		return $.dsDirectCall({
			method: "GetORMjestoFields",
			params: [  ]
		});
	}
	
	function ObrisiRjesenjaNadatum(datum){
		return $.dsDirectCall({
			method: "ObrisiRjesenjaNadatum",
			params: [ datum ]
		});
	}
	
	function NapuniRjZaObrisiNadatum(datum){
		return $.dsDirectCall({
			method: "NapuniRjZaObrisiNadatum",
			params: [ datum ]
		});
	}
	
	function DRazdobObrisiZaImportGen(importGen){
		return $.dsDirectCall({
			method: "DRazdobObrisiZaImportGen",
			params: [ importGen ]
		});
	}
	
	function DajBrZahtjevaZaImportGen(importGen){
		return $.dsDirectCall({
			method: "DajBrZahtjevaZaImportGen",
			params: [ importGen ]
		});
	}
	
	function NapuniDaneZaOsnovu(godina, redni, osnova){
		return $.dsDirectCall({
			method: "NapuniDaneZaOsnovu",
			params: [ godina, redni, osnova ]
		});
	}
	
	function PostojeZahtjeviZaDopust(godina, redni){
		return $.dsDirectCall({
			method: "PostojeZahtjeviZaDopust",
			params: [ godina, redni ]
		});
	}
	
	function DopustObrisi(godina, redni){
		return $.dsDirectCall({
			method: "DopustObrisi",
			params: [ godina, redni ]
		});
	}
	
	function DOsnovaObrisi(godina, redni, osnova){
		return $.dsDirectCall({
			method: "DOsnovaObrisi",
			params: [ godina, redni, osnova ]
		});
	}
	
	function DRazdobObrisi(drazdob){
		return $.dsDirectCall({
			method: "DRazdobObrisi",
			params: [ drazdob ]
		});
	}
	
	function GetDRazdobFields(sto,minprikaz) {
		return $.dsDirectCall({ 
			method: "GetDRazdobFields",
			params: [sto,minprikaz]
		});
	}
	
	function GetDOsnovaFields(minprikaz) {
		return $.dsDirectCall({ 
			method: "GetDOsnovaFields",
			params: [minprikaz]
		});
	}
	
	
	function RjesenjeObrisi(rjesenje){
		return $.dsDirectCall({
			method: "RjesenjeObrisi",
			params: [ rjesenje ]
		});
	}
	
	function UskladiStazRadnika(kradnik, vrsta){
		return $.dsDirectCall({
			method: "UskladiStazRadnika",
			params: [ kradnik, vrsta ]
		});
	}
	
	function GetNoviRedniZaKRadnik(kradnik){
		return $.dsDirectCall({
			method: "GetNoviRedniZaKRadnik",
			params: [ kradnik ]
		});
	}
	
	function IzracunajStazIzmedju(param){
		return $.dsDirectCall({
			method: "IzracunajStazIzmedju",
			params: [ param ]
		});
	}
	
	function AzurirajOdb(kradnik){
		return $.dsDirectCall({
			method: "AzurirajOdb",
			params: [ kradnik ]
		});
	}

	function SpremiKRadnikInitDefaults(krvrsta, defaults){
		return $.dsDirectCall({
			method: "SpremiKRadnikInitDefaults",
			params: [ krvrsta, defaults ]
		});
	}

	function GenerirajERVZaKRadnik(kradnik){
		return $.dsDirectCall({
			method: "GenerirajERVZaKRadnik",
			params: [ kradnik ]
		});
	}
	
	function ObiteljObrisi(kradnik, clan){
		return $.dsDirectCall({
			method: "ObiteljObrisi",
			params: [ kradnik, clan ]
		});
	}
	function RUSavrObrisi(rusavr){
		return $.dsDirectCall({
			method: "RUSavrObrisi",
			params: [ rusavr ]
		});
	}

	function SJezikObrisi(kradnik, sjezik){
		return $.dsDirectCall({
			method: "SJezikObrisi",
			params: [ kradnik, sjezik ]
		});
	}
	function KROstaloObrisi(krostalo){
		return $.dsDirectCall({
			method: "KROstaloObrisi",
			params: [ krostalo ]
		});
	}
	function StaroPObrisi(kradnik, redni){
		return $.dsDirectCall({
			method: "StaroPObrisi",
			params: [ kradnik, redni ]
		});
	}
	function PodsjetiObrisi(podsjeti){
		return $.dsDirectCall({
			method: "PodsjetiObrisi",
			params: [ podsjeti ]
		});
	}
	
	function GetObiteljFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetObiteljFields",
			params: [kradnik]
		});
	}
	function GetRUSavrFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetRUSavrFields",
			params: [kradnik]
		});
	}
	function GetSJezikFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetSJezikFields",
			params: [kradnik]
		});
	}
	function GetKROstaloFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetKROstaloFields",
			params: [kradnik]
		});
	}
	function GetStaroPFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetStaroPFields",
			params: [kradnik]
		});
	}
	function GetKorisnik2RadnikaFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetKorisnik2RadnikaFields",
			params: [kradnik]
		});
	}
	
	function GetKRUgovorFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetKRUgovorFields",
			params: [kradnik]
		});
	}
	
	function GetOcListKRFields(kradnik) {
			return $.dsDirectCall({ 
				method: "GetOcListKRFields",
				params: [kradnik]
			});
		}
	
	
	function GetPodsjetiFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetPodsjetiFields",
			params: [kradnik]
		});
	}
	

	function ObrisiKPonasanja(NRMjestoK) { 
		return $.dsDirectCall({
			method: "ke/ObrisiKPonasanja",
			params: [NRMjestoK]
		});
	};

	function GetNRMjestoKOcjene(NRMjesto) {
		return $.dsDirectCall({
			method: "ke/GetNRMjestoKOcjene",
			params: [NRMjesto]
		});
	};

	function PodaciORadnikuNaslijedi(KRadnik) {
		return $.dsDirectCall({
			method: "ke/PodaciORadnikuNaslijedi",
			params: [KRadnik]
		});
	};

	function KRadnikById(KRadnik) {
		return $.dsDirectCall({
			method: "ke/KRadnikById",
			params: [KRadnik]
		});
	}

	function GetBrojMjeseci(datumOd, datumDo) {
		var datumi = JSON.stringify({ DatumOd: datumOd, DatumDo: datumDo });
		return $.dsDirectCall({
			method: "ke/GetBrojMjeseci",
			params: [{ datum: datumi }]
		});
	}

	function PonistiKOcjene(OcListO) {
		return $.dsDirectCall({
			method: "ke/PonistiKOcjene",
			params: [OcListO]
		});
	};

	function PonistiCOcjene(OcListO) {
		return $.dsDirectCall({
			method: "ke/PonistiCOcjene",
			params: [OcListO]
		});
	};
	
	function GetRjesenjaPodredEvents(params){
		return $.dsDirectCall({
			method: "GetKalendarEvents",
			params: [ params ]
		});
	} 	  

	function GetKalendarKRadnik(params){
		return $.dsDirectCall({
			method: "GetKalendarKRadnik",
			params: [ params ]
		});
	} 
	
	function GetKalendarOdjel(params){
		return $.dsDirectCall({
			method: "GetKalendarOdjel",
			params: [ params ]
		});
	} 
	
	function GetKalendarOVrsta(params){
		return $.dsDirectCall({
			method: "GetKalendarOVrsta",
			params: [ params ]
		});
	} 
	
	
	function GetERVEvents(params){
		return $.dsDirectCall({
			method: "GetERVEvents",
			params: [ params ]
		});
	} 	  

	function GetKalendarRadnik(params){
		return $.dsDirectCall({
			method: "GetKalendarRadnik",
			params: [ params ]
		});
	} 
	
	function GetKalendarRMjesto(params){
		return $.dsDirectCall({
			method: "GetKalendarRMjesto",
			params: [ params ]
		});
	} 
	
	function GetKalendarVRada(params){
		return $.dsDirectCall({
			method: "GetKalendarVRada",
			params: [ params ]
		});
	} 
	
	function Odobravanje(params, callback){
		return $.dsDirectCall({
			method: "Odobravanje",
			params: [ params ]
		})
		.done(callback);
	} 
	
	function StornirajZahtjevBezStatusa(iDZahtjev, callback){
		return $.dsDirectCall({
			method: "StornirajZahtjevBezStatusa",
			params: [ iDZahtjev ]
		})
		.done(callback);
	} 
	function DZahtjevMozeStorno(iDZahtjev, callback){
		return $.dsDirectCall({
			method: "DZahtjevMozeStorno",
			params: [ iDZahtjev ]
		})
		.done(callback);
	} 
	
	function GetRUsavrRadnikaFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetRUsavrRadnikaFields",
			params: [kradnik]
		});
	}
	function GetKROstaloRadnikaFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetKROstaloRadnikaFields",
			params: [kradnik]
		});
	}
	function GetObiteljRadnikaFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetObiteljRadnikaFields",
			params: [kradnik]
		});
	}
	function GetORMjestoRadnikaFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetORMjestoRadnikaFields",
			params: [kradnik]
		});
	}
	function GetStaroPRadnikaFields(kradnik) {
		return $.dsDirectCall({ 
			method: "GetStaroPRadnikaFields",
			params: [kradnik]
		});
	}
	function GetEduPlanSFields() {
		return $.dsDirectCall({ 
			method: "GetEduPlanSFields"
		});
	}
	function GetEduPlanSTrFields() {
		return $.dsDirectCall({ 
			method: "GetEduPlanSTrFields"
		});
	}
	function GetEduKatalogTrFields() {
		return $.dsDirectCall({ 
			method: "GetEduKatalogTrFields"
		});
	}
	function EduPlanGeneriraj(eduplan) {
		return $.dsDirectCall({ 
			method: "EduPlanGeneriraj",
			params: [eduplan]
		});
	}
	function GetEduPlanSTFields() {
		return $.dsDirectCall({ 
			method: "GetEduPlanSTFields"
		});
	}
	
	function EduPlanSObrisi(eduPlanS){
		return $.dsDirectCall({
			method: "EduPlanSObrisi",
			params: [ eduPlanS ]
		});
	}
	
	function EduPlanSTrObrisi(eduPlanSTr){
		return $.dsDirectCall({
			method: "EduPlanSTrObrisi",
			params: [ eduPlanSTr ]
		});
	}
	
	function GetSlikaRadnika(kradnik){
		return $.dsDirectCall({
            method: "GetSlikaRadnika",
            params: [ kradnik ]
        });
	}

	function SpremiIRekapRadnikPredlozak(predlozak) {
		return $.dsDirectCall({
			method: "SpremiIRekapRadnikPredlozak",
			params: [ predlozak ]
		});
	}

	function ObrisiIRekapRadnikPredlozak(nazivPredloska) {
		return $.dsDirectCall({
			method: "ObrisiIRekapRadnikPredlozak",
			params: [ nazivPredloska ]
		});
	}
	
	function KRadnikGetPromjenePodataka(iKRadnik, iGrupaPodataka, iRedni) { 
		return $.dsDirectCall({
			method: "ke/KRadnikGetPromjenePodataka",
			params: [iKRadnik, iGrupaPodataka, iRedni]
		});
	};

	function DajPopisPromjenaPKRadnik(iKRadnik) {
		return $.dsDirectCall({
			method: "ke/DajPopisPromjenaPKRadnik",
			params: [iKRadnik]
		});
	};

	function DajPopisPromjenaPrikazKRadnik(iKRadnik) {
		return $.dsDirectCall({
			method: "ke/DajPopisPromjenaPrikazKRadnik",
			params: [iKRadnik]
		});
	};
	
	
	function VanjskiObrisi(vanjski) { 
		return $.dsDirectCall({
			method: "VanjskiObrisi",
			params: [vanjski]
		});
	};
	
	function ImportIzSc(partner, datumod, datumdo) { 
		return $.dsDirectCall({
			method: "ImportIzSc",
			params: [partner, datumod, datumdo]
		});
	};

} (konto.ke.api = {}));

